import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"
import saleNonPartner from "@/middlewares/saleNonPartner"

const salesRoutes: RouteRecordRaw[] = [
  {
    path: "/sales/contracts",
    name: "sales-contracts-management",
    component: () => import("@/views/subscriptions/SalesContractsManagement.vue"),
    meta: {
      middleware: [auth],
      title: "subscriptions.page_title",
    },
  },
  {
    path: "/sales/prospects",
    name: "sales-prospects",
    component: () => import("@/views/sales/SalesProspects.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "sales_prospects.page_title",
    },
  },
  {
    path: "/sales/prospects/:id",
    name: "sales-prospect-details",
    component: () => import("@/views/sales/SalesProspectDetails.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "sales_prospects.detail.page_title",
    },
  },
  {
    path: "/sales/contracts/establishment/:id",
    name: "sales-establishment-details",
    component: () => import("@/views/subscriptions/SalesEstablishmentDetails.vue"),
    meta: {
      middleware: [auth],
      title: "Détails de l'établissement",
    },
  },
  {
    path: "/sales/campaigns",
    name: "sales-campaigns",
    component: () => import("@/views/sales/SalesCampaigns.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "campaigns.page_title",
    },
  },
  {
    path: "/sales/campaigns/create",
    name: "sales-campaign-create",
    component: () => import("@/views/sales/SalesCampaignForm.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "campaigns.create_campaign",
    },
  },
  {
    path: "/sales/campaigns/:id/edit",
    name: "sales-campaign-edit",
    component: () => import("@/views/sales/SalesCampaignForm.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "campaigns.edit_campaign",
    },
  },
  {
    path: "/sales/campaigns/:id",
    name: "sales-campaign-details",
    component: () => import("@/views/sales/SalesCampaignDetails.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "Détails de la campagne",
    },
  },
  {
    path: "/sales/tracking-analytics",
    name: "sales-tracking-analytics",
    component: () => import("@/views/sales/SalesTrackingAnalytics.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "sales_tracking_analytics.page_title",
    },
  },
  {
    path: "/sales/ai-costs",
    redirect: (to) => ({
      name: "sales-assistant-costs",
      query: to.query,
    }),
  },
  {
    path: "/sales/assistant",
    component: () => import("@/views/sales/SalesAssistantHubLayout.vue"),
    meta: {
      middleware: [auth, saleNonPartner],
      title: "sales_assistant_hub.page_title",
    },
    redirect: { name: "sales-assistant-costs" },
    children: [
      {
        path: "costs",
        name: "sales-assistant-costs",
        component: () => import("@/views/sales/SalesAssistantCostsPanel.vue"),
        meta: {
          title: "sales_assistant_hub.page_title",
        },
      },
      {
        path: "quality",
        name: "sales-assistant-quality",
        component: () => import("@/views/sales/SalesAssistantQualityPanel.vue"),
        meta: {
          title: "sales_assistant_hub.page_title",
        },
      },
    ],
  },
]

export default salesRoutes
